import { gql } from '@apollo/client';

const FavoritedAnalysisFieldsFragment = gql`
  fragment FavoritedAnalysisFields on Analysis {
    id
    schema {
      id
    }
    queryType
    display
    description
    pref {
      chartPref
    }
  }
`;

export const GET_FAVORITED_ANALYSES = gql`
  query GetFavoritedAnalyses(
    $userOnly: Boolean
    $schemaIds: [ID!]
    $kind: AnalysisKind
    $queryTypes: [QueryType!]
    $term: String
    $statuses: [AnalysisStatus]
    $includes: [ID!]!
    $filter: AnalysisFilter
    $favoriteOnly: Boolean
    $pagination: Pagination!
  ) {
    searchAnalysis(
      term: $term
      schemaIds: $schemaIds
      queryTypes: $queryTypes
      kind: $kind
      userOnly: $userOnly
      statuses: $statuses
      pagination: $pagination
      includes: $includes
      filter: $filter
      favoriteOnly: $favoriteOnly
    ) {
      entities {
        ...FavoritedAnalysisFields
      }
    }
  }
  ${FavoritedAnalysisFieldsFragment}
`;
